import { styled } from 'linaria/react';
import { breakpoints } from '../../../../media';

export const ConfiguratorsListContainer = styled.div`
	display: grid;
	grid-auto-rows: 333px;
	grid-template-columns: repeat(4, 1fr);
	margin-top: 40px;
	margin-bottom: 40px;
	column-gap: 32px;
	row-gap: 24px;
	${breakpoints.to.largeDesktop} {
		margin-top: 32px;
		column-gap: 20px;
	}
	${breakpoints.to.desktop} {
		grid-template-columns: repeat(6, 1fr);
		column-gap: 12px;
	}
	${breakpoints.to.tablet} {
		grid-auto-rows: auto;
		grid-template-columns: 1fr;
		margin-top: 24px;
		column-gap: 0;
		row-gap: 20px;
	}
`;
